import type { StoryScript } from './types';
import { SOMMER_I_HAVEN } from './level-1/sommer-i-haven';
import { UGLE_I_TRAET } from './level-1/ugle-i-traet';
import { PAA_TUR_I_SKOVEN } from './level-1/paa-tur-i-skoven';

export type { StoryScript, StoryBeat, StoryBlankSpec } from './types';

/** Alle grundfortællinger — tilføj flere filer i level-1/ efterhånden. */
export const STORY_SCRIPTS: StoryScript[] = [
  UGLE_I_TRAET,
  SOMMER_I_HAVEN,
  PAA_TUR_I_SKOVEN,
];

const BY_ID = new Map(STORY_SCRIPTS.map((s) => [s.id, s]));

export function getStoryScript(id: string): StoryScript | undefined {
  return BY_ID.get(id);
}
